/* eslint-disable */
import React from 'react'
import DashboardIcon from 'components/icons/DashboardIcon'
import RoleIcon from 'components/icons/RoleIcon'
import AppliedIcon from 'components/icons/AppliedIcon'
import DriveIcon from 'components/icons/DriveIcon'
import DriveIconNew from 'components/icons/DriveIconNew'
import OfferIcon  from 'components/icons/OfferIconNew'
import CoursesIcon from 'components/icons/CoursesIcon'
import Button from 'components/Button'
import { useSelector } from 'react-redux'
import { Menu, Badge } from 'antd'
import { Link } from 'react-router-dom'
import './style.css'
import {
  StyledFlex1,
  TopNavMenu,
  LeftDiv,
  RightDiv,
  SpanNewCount
} from 'modules/Page/Components/Partials/style'

const TopNavigation = () => {
  const ddd = window.location.pathname

  const metricsData = useSelector(
    state => state?.appliedRoleData?.appliedRoleMetrics
  )

  const newroleCount = useSelector(
    state => state?.appliedRoleData?.newRoleCount
  )
  const getSelectedkey = () => {
    if (ddd?.includes('roles/viewrole')) {
      return [`/roles`]
    } else {
      return [ddd]
    }
  }
  const authToken = useSelector(
    state => state?.auth?.token
  )

  const { ASS_APP_URL } = process.env

  const openAssessmentPortal = () => {
    // Open the external assessment portal in a new tab. Guard against a
    // missing ASS_APP_URL: without this, the template literal becomes
    // "undefined/signin?token=..." — a RELATIVE url that window.open resolves
    // against the student domain, so the user lands back on the student app
    // (catch-all route → Dashboard) instead of the assessment portal.
    // Also strip any trailing slash so we don't emit "host//signin".
    const base = (ASS_APP_URL || '').trim().replace(/\/+$/, '')
    if (!base) {
      console.error('ASS_APP_URL is not configured — cannot open the assessment portal')
      return
    }
    window.open(`${base}/signin?token=${authToken}`, '_blank', 'noopener,noreferrer');
  }
console.log(newroleCount,'newroleCount')

  return (
    <StyledFlex1>
      <LeftDiv>
        <TopNavMenu mode="horizontal" selectedKeys={getSelectedkey()} >
          <Menu.Item
            key="/dashboard"
            icon={<DashboardIcon className="iconStyle" />}
            className="iconStyle"
          >
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item
            key="/roles"
            icon={<RoleIcon className="iconStyle" />}
            className="iconStyle"
          >
        <Link to="/roles">
          {/* <Badge size="small" count={metricsData?.newRolesCount} style={{ backgroundColor: '#3249D7', marginRight:'-8px' }} offset={[0, -3]}> */}
            <Link to="/roles" style={{ marginTop: '8px' }}>Roles {newroleCount?.countData > 0 &&<SpanNewCount>(New {newroleCount?.countData})</SpanNewCount>}</Link>
          {/* </Badge> */}
        </Link>
         </Menu.Item>
          <Menu.Item
            key="/applied_roles"
            icon={<AppliedIcon className="iconStyle" />}
            className="iconStyle"
          >
            <Link to="/applied_roles">Applied Roles</Link>
          </Menu.Item>

          
          <Menu.Item 
            key="/assessment" 
            icon={<CoursesIcon className="iconStyle" />}
            className="iconStyle"
            onClick={openAssessmentPortal}
          >
            <span>Assessments</span>
          </Menu.Item>



          <Menu.Item
            key="/drives"
            icon={<DriveIconNew className="iconStyle" />}
            className="iconStyle"
          >
          <Link to="/drives">
          <Badge size="small" count={metricsData?.newInterviewOrDriveCount} style={{ backgroundColor: '#3249D7', marginRight:'-8px' }} offset={[0, -3]}>
            <Link to="/drives" style={{ marginTop: '8px' }}>Interview / Drive</Link>
          </Badge>
          </Link>
          </Menu.Item>
          <Menu.Item
            key="/offerReceived"
            icon={<OfferIcon className="iconStyle" />}
            className="iconStyle"
          >
        <Link to="/offerReceived">
          <Badge size="small" count={metricsData?.newOffersCount} style={{ backgroundColor: '#3249D7', marginRight:'-8px' }} offset={[0, -3]}>
            <Link to="/offerReceived" style={{ marginTop: '8px' }}>Offers Received</Link>
          </Badge>
        </Link>
          </Menu.Item>
          <Menu.Item
            key="/events"
            icon={<DriveIcon className="iconStyle" />}
            className="iconStyle"
          >
          <Link to="/events">
          <Badge size="small" style={{ backgroundColor: '#3249D7', marginRight:'-8px' }} offset={[0, -3]}>
            <Link to="/events" style={{ marginTop: '8px' }}>Events</Link>
          </Badge>
          </Link>
          </Menu.Item>
        </TopNavMenu>
      </LeftDiv>
      <RightDiv>
        <Link to="/resume">
          <Button.Secondary text={'My Resume'} width={'100px'} borderRadius={'15px'}/>
        </Link>
      </RightDiv>
    </StyledFlex1>
  )
}
export default TopNavigation
